import { Grid } from '@mui/material';

import { TextField } from '@occc-app/design-system';

import { isFloat } from '../utils';

const LocationScanDataFormContent = () => (
  <Grid container columnSpacing={3} rowSpacing={1}>
    <Grid item xs={6} sm={3}>
      <TextField
        name='altriaRcn'
        label='Altria RCN'
        margin='normal'
        fieldProps={{
          validate: isFloat,
        }}
      />
    </Grid>
    <Grid item xs={6} sm={3}>
      <TextField
        name='altriaMan'
        label='Altria MAN'
        margin='normal'
        fieldProps={{
          validate: isFloat,
        }}
      />
    </Grid>
    <Grid item xs={6} sm={3}>
      <TextField name='rjrAccountNumber' label='RJR Account Number' margin='normal' />
    </Grid>
  </Grid>
);

export default LocationScanDataFormContent;
